// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Subscribe_scroll-black__u_jed","wrapper":"Subscribe_wrapper__2xd3w"};